exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.extraNameWidth[data-v-466cba20] {\n  width: 40%;\n}\n.addRemoveWidth[data-v-466cba20] {\n  width: 10%;\n}\n.extraRow[data-v-466cba20] {\n  height: 3rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-466cba20","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reservations/NewReservation/Resume/AddExtra.vue
// module id = 2907
// module chunks = 0